import { render } from "./Pontaj.vue?vue&type=template&id=731ba5e2&scoped=true&ts=true"
import script from "./Pontaj.vue?vue&type=script&lang=ts"
export * from "./Pontaj.vue?vue&type=script&lang=ts"

import "./Pontaj.vue?vue&type=style&index=0&id=731ba5e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731ba5e2"]])

export default __exports__